import React, { createContext, useContext, useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useMobileTheme } from '../hooks/useMobileTheme';
import { getMobileTheme } from '../theme/mobileTheme';

const MobileThemeContext = createContext(null);

export function MobileThemeProvider({ children }) {
  const themeState = useMobileTheme();
  const theme = useMemo(() => getMobileTheme(themeState.variant), [themeState.variant]);

  return (
    <MobileThemeContext.Provider value={themeState}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </MobileThemeContext.Provider>
  );
}

export function useMobileThemeContext() {
  const ctx = useContext(MobileThemeContext);
  if (!ctx) {
    throw new Error('useMobileThemeContext must be used within MobileThemeProvider');
  }
  return ctx;
}
